import "./InputField.scss";

interface InputFieldProps {
  label: string;
  value: string;
  type: string;
  disabled?: boolean;
  invalidMsg?: string;
  onChange: (value: string) => void;
  darkMode: boolean;
}

const InputField = (props: InputFieldProps) => {
  return (
    <div className={"input-field-wrapper" + (props.darkMode ? " dark" : "")}>
      <label className="input-label">{props.label}</label>
      <input
        type={props.type}
        className="input-text"
        disabled={props.disabled}
        value={props.value as string}
        onChange={(e) => props.onChange(e.target.value)}
      />
      {props.invalidMsg && (
        <div className="invalid-msg">{props.invalidMsg}</div>
      )}
    </div>
  );
};

export default InputField;
